import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "s-carousel-page-nav"
}

import Icon from '@/elements/Icon.vue';
import type { CarouselPageNavProps } from '@/types/sections/carousel-page-nav';


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselPageNav',
  props: {
    prevClass: { default: 'prev' },
    nextClass: { default: 'next' },
    paginationClass: { default: 'pagination' },
    showNavigation: { type: Boolean, default: true },
    show: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.showNavigation)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(['s-carousel-page-nav__control', __props.prevClass]),
              "aria-label": "Previous"
            }, [
              _createVNode(Icon, { name: "arrow-left" })
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['s-carousel-page-nav__pagination', __props.paginationClass])
        }, null, 2),
        (__props.showNavigation)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: _normalizeClass(['s-carousel-page-nav__control', __props.nextClass]),
              "aria-label": "Next"
            }, [
              _createVNode(Icon, { name: "arrow-right" })
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})